import { colors } from '../../css';

export const railStyle = {
  default: { backgroundColor: colors.colorGrey04 },
  disabled: { backgroundColor: colors.colorGrey05 }
};

export const trackStyle = {
  default: [{ backgroundColor: colors.colorBlue }],
  disabled: [{ backgroundColor: colors.colorGrey04 }]
};

export const handleStyle = {
  default: [
    { border: `solid 4px ${colors.colorBlue}`, boxShadow: '0 0 0 3px #FFF' },
    { border: `solid 4px ${colors.colorBlue}`, boxShadow: '0 0 0 3px #FFF' }
  ],
  disabled: [
    { border: `solid 4px ${colors.colorGrey04}`, boxShadow: '0 0 0 3px #FFF' },
    { border: `solid 4px ${colors.colorGrey04}`, boxShadow: '0 0 0 3px #FFF' }
  ]
};
